import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Box, Spacer } from '@eatclubcode/ec-component-library';
import useStyles from './TextListStyles';
import CheckInCircle from '../../assets/icons/check_in_circle_no_outline.svg';

/**
 * Displays a list of text items, either with icons or numbers
 *
 * Items can either be a string or an object with {id, value}
 */
export const TextList = ({ items = [], numbered = false, style = {} }) => {
  const classes = useStyles({ style });
  const theme = useTheme();

  return (
    <Spacer className={classes.root}>
      {items.map((item, index) => (
        <Box className={classes.item} key={item?.id ?? item}>
          {numbered ? (
            <Box className={classes.number}>{index + 1}</Box>
          ) : (
            <Box>
              <CheckInCircle color={theme.colors.checkBackground} />
            </Box>
          )}
          <Box>{item?.value ?? item}</Box>
        </Box>
      ))}
    </Spacer>
  );
};
